<template>
  <el-card shadow="always" v-if="state == 'CHANGED'">
    <div slot="header" class="clearfix">
      <span>Dados do objeto</span>
    </div>
    <div>
      <el-form ref="form" :model="objectForm" :label-position="labelPosition" label-width="180px">
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item class="no-margin-bottom" :label="$t('embalagem')" prop="package">
              <PackingList ref="package" v-model="objectForm.package" v-on:selected="selected"
                :current="objectForm.package" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5" justify="center">
          <el-col :span="24">
            <el-alert
              class="alert-black-text center-alert"
              title=""
              :closable="false"
              description="Os serviços adicionais A.R - A.R-Eletrônico e MP - Mão própria - Não estão disponíveis para os serviços EXPRESSO 1 e ECONOMICO 1."
            />
          </el-col>
        </el-row>
        <el-row :gutter="5" justify="left" type="flex">
          <el-col :xs="12" :sm="12" :md="6" :lg="7" :xl="6">
            <el-form-item class="no-margin-bottom" :label="$t('ar')" prop="reg">
              <el-switch
                v-model="objectForm.ar"
                @change="warning('ar', 'ardigital')"
                active-color="#67C23A"
                inactive-color="#DCDFE6"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
            <el-form-item class="no-margin-bottom" :label="$t('ar-digital')" prop="ardigital">
              <el-switch
                v-model="objectForm.ardigital"
                @change="warning('ardigital', 'ar')"
                active-color="#67C23A"
                inactive-color="#DCDFE6"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
            <el-form-item class="no-margin-bottom" :label="$t('mp')" prop="ownhand">
              <el-switch
                v-model="objectForm.ownhand"
                active-color="#67C23A"
                inactive-color="#DCDFE6"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
            <el-form-item class="no-margin-bottom" prop="ap">
              <template slot="label">
                <span>A.P.</span>
                <ArtigosPerigososPopover />
              </template>
              <el-switch v-model="objectForm.ap"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="18" :lg="12" :xl="12">
            <el-form-item class="no-margin-bottom" :label="$t('peso') + '(g)'" prop="weight" :required="true">
              <el-input type="number" min="1" step="1" pattern="[0-9]" v-model="objectForm.weight"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="18" :lg="12" :xl="12">
            <el-form-item class="no-margin-bottom" :label="$t('quantidade')" prop="quantity">
              <el-input-number v-model="objectForm.quantity" :min="1" :max="10000"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="bottom clearfix right" style="margin-bottom: 10px">
      <el-button type="primary" @click="confirm">Confirmar</el-button>
    </div>
  </el-card>
  <el-card v-else shadow="always" style="min-height: 143px">
    <el-row :gutter="5">
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <label style="font-weight: bold">Embalagem:</label>&nbsp;
        <label>{{ packagename }}</label>
      </el-col>
    </el-row>
    <el-row :gutter="5" class='embalagem-aligment'>
      <el-col :xs="2" :sm="2" :md="2" :lg="3" :xl="3">
        <el-tag v-show="objectForm.ar">A.R.</el-tag>
      </el-col>
      <el-col :xs="2" :sm="2" :md="2" :lg="3" :xl="3">
        <el-tag v-show="objectForm.ardigital">A.R. Eletrônico</el-tag>
      </el-col>
      <el-col :xs="2" :sm="2" :md="2" :lg="3" :xl="3">
        <el-tag v-show="objectForm.ownhand">Mãos Próprias</el-tag>
      </el-col>
      <el-col :xs="2" :sm="2" :md="2" :lg="3" :xl="3">
        <el-tag v-show="objectForm.ap">A.P.</el-tag>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="18" :sm="18" :md="18" :lg="12" :xl="12">
        <label style="font-weight: bold">Peso:</label>&nbsp;
        <label> {{ objectForm.weight }} </label>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <el-button type="info" @click="changed" size="mini">Alterar</el-button>
      </el-col>
    </el-row>
  </el-card>
</template>
<script>
//import { UserService } from "@/services/users/user.services";
import PackingList from "@/xpost/views/register/packing/PackingList";
import ArtigosPerigososPopover from "@/components/ArtigosPerigososPopover";

export default {
  name: "PrePostObject",
  props: ["state", "labelPosition"],
  components: { PackingList, ArtigosPerigososPopover },
  computed: {
    packagename() {
      const vm = this;
      if (vm.$refs.package && vm.objectForm.package) {
        const record = vm.$refs.package.find(vm.objectForm.package);
        if (record) {
          return record.name;
        }
      }
      return vm.objectForm.package;
    },
  },
  methods: {
    confirm() {
      const vm = this;
      vm.$emit("confirm");
    },
    warning(a, b) {
      const vm = this;
      if (vm.objectForm[a]) vm.objectForm[b] = false;
    },
    selected() {
      const vm = this;
      if (vm.$refs.package && vm.objectForm.package) {
        const record = vm.$refs.package.find(vm.objectForm.package);
        if (record) {
          vm.measure.width = +record.width;
          vm.measure.height = +record.height;
          vm.measure.length = +record.length;
        }
      }
    },
    changed() {
      const vm = this;
      vm.$emit("changed");
    },
    clear() {
      const vm = this;
      vm.objectForm.ownhand = false;
      vm.objectForm.ar = false;
      vm.objectForm.weight = 0;
      vm.objectForm.quantity = 1;
      vm.objectForm.package = "";
      vm.objectForm.ardigital = false;
      vm.objectForm.ap = false;
    },
  },
  data() {
    return {
      loading: false,
      measure: {
        width: 0,
        height: 0,
        length: 0,
      },
      objectForm: {
        ownhand: false,
        ar: false,
        weight: 0,
        quantity: 1,
        package: "",
        ardigital: false,
        ap: false,
      },
    };
  },
};
</script>
<style scoped>
::v-deep(.alert-black-text .el-alert__description) {
  color: #000000;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
}

.center-alert {
  text-align: center;
}

/* Garante que os switches quebrem linha quando necessário */
::v-deep(.el-row--flex) {
  flex-wrap: wrap !important;
}

.centered-label {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  /* Optional: prevent label text from wrapping if not desired */
  /* white-space: nowrap; */
  gap: 4px; /* space between text and popover */
}
.embalagem-aligment > .el-col{
  min-width: 80px;
}
</style>
